var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isIncoming && _vm.value.isGranted === null ? _c('v-layout', {
    staticStyle: {
      "gap": "10px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('grant-respond', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "outlined": "",
            "width": "73",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v("수락")])])];
      }
    }], null, false, 350710137)
  }, 'grant-respond', {
    value: _vm.value,
    program: _vm.program,
    isGranted: true,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer
  }, false), {
    input: _vm.input
  })), _c('grant-respond', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "outlined": "",
            "width": "73",
            "color": "grey-d"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey--text"
        }, [_vm._v("거부")])])];
      }
    }], null, false, 3909286066)
  }, 'grant-respond', {
    value: _vm.value,
    program: _vm.program,
    isGranted: false,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer
  }, false), {
    input: _vm.input
  }))], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }